<template>
  <div class="page">
    <div style="text-align:left;">
      <div class="contentTop">
        <div class="phoneTop">绑定手机号</div>
        <yd-icon class="imageTop" name="error-outline" @click.native="closeDialogAction()"></yd-icon>
      </div>
      <div style="margin:20px 15px 0px 15px;">
        <div class="textLabel">手机号码</div>
        <input class="inputPhone"
              type="tel"
              placeholder="输入手机号"
              v-model="phone"
              @blur.prevent="inputCloseFocus">
      </div>
      <div style="width:100%;
                  height:1px;
                  background-color:#eee;">
      </div>
    </div>
    <div style="text-align:left;">
      <div style="display:flex;
                  justify-content:space-between;
                  align-items:center;
                  margin:15px;
                  margin-bottom:0px;">
        <div style="max-width:60%;">
          <div class="textLabel">验证码</div>
          <input class="inputCode"
                  type="tel"
                  placeholder="输入收到的验证码"
                  @blur.prevent="inputCloseFocus"
                  v-model="code">
        </div>
        <div
          @click="getCodeAction()"
          class="codeButton">{{word}}
        </div>
      </div>
      <div style="width:100%;
                  height:1px;
                  background-color:#eee;">
      </div>
    </div>
    <button
      class="confirmButton"
      @click="bindMobileAction()"
      type="primary">确定
    </button>
  </div>
</template>

<script>
import appService from "@/services/request/appService";
import store from "store";
import { setTimeout } from 'timers';

export default {
  name: "BindMobile",
  data() {
    return {
      mine: {},
      userId: "",
      code: "",
      phone: "",
      word: "获取验证码",
      countdown: 60,
      accessToken:'',
      isDisable:false,
    };
  },
  mounted: function() {
    this.$nextTick(function() {
      this.mine = store.get('mine')
    });
  },
  methods: {
    close(bindOk) {
      this.$emit("listenToVisibleChange", false, bindOk);
    },
    setTime() {
      if (this.countdown == 0) {
        this.isDisable = false;
        this.word = "重新发送";
        this.countdown = 60;
      } else {
        this.isDisable = true;
        this.word = this.countdown + "s";
        this.countdown--;
        var self = this;
        setTimeout(() => {
          self.setTime();
        }, 1000);
      }
    },
    closeDialogAction() {
      this.close(false)
    },
    getCodeAction() {
      if (!this.phone) {
        this.$dialog.toast({
          mes: '请输入手机号码',
          timeout: 1500,
          icon: 'error',
        });
        return;
      }
      if (this.isDisable) {
        return;
      }
      appService
        .getCodeForBind({ 
          mobile: this.phone, 
          userId: this.mine.unionId,
          iid: this.mine.iid
        })
        .then(result => {
          this.setTime();
          this.$dialog.toast({
            mes: '验证码已发送',
            timeout: 1500,
            icon: 'success',
          });
        }, error => {
          this.$dialog.toast({
            mes: '验证码获取失败',
            timeout: 1500,
            icon: 'error',
          });
        });
    },
    bindMobileAction() {
      if (!this.phone) {
        this.$dialog.toast({
          mes: '请输入手机号码',
          timeout: 1500,
          icon: 'error',
        });
        return;
      }
      if (!this.code) {
        this.$dialog.toast({
          mes: '请输入验证码',
          timeout: 1500,
          icon: 'error',
        });
        return;
      }
      appService
        .bindMobile({
          loginName: this.phone,
          userId: this.mine.unionId,
          verifyCode: this.code,
          iid: this.mine.iid
        })
        .then(
          result => {
            this.close(true);
            this.$dialog.toast({
              mes: '绑定成功',
              timeout: 1500,
              icon: 'success'
            })
            setTimeout(() => {
              location.reload()
            }, 1000);
          },
          error => {
            var errorStr = '绑定失败'
            if (error && error.sub_msg) {
              errorStr = error.sub_msg
            } else if(error && error.msg) {
              errorStr = error.msg
            }
            this.$dialog.toast({
              mes: errorStr,
              timeout: 1500,
              icon: 'error',
            });
          }
        );
    },
    inputCloseFocus() {
      setTimeout(() => {
          window.scrollTo(0, 0);
      }, 100)
    }
  }
};
</script>

<style scoped>
.page {
  font-size: 0.28rem;
  background-color: white;
}
.contentTop {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.textLabel {
  color: #999;
  font-size: 14px;
}
.phoneTop {
  font-size: 20px;
  font-style: bold;
  color: #212121;
  margin-top: 30px;
}
.imageTop {
  top: 0px;
  width: 25px;
  height: 25px;
  padding-top: 8px;
  padding-right: 36px;
  right: 0px;
  position: absolute;
}
.confirmButton{
  margin-top:25px;
  margin-bottom:25px;
  font-size:16px;
  width:50%;
  height: 36px;
  margin: 25px 25%;
  border: none;
  border-radius:18px;
  color:white;
  background-color:#64b572;
}
.codeButton{
  border:solid 1px #64b572;
  border-radius:12px;
  height:24px;
  font-size:11px;
  line-height:24px;
  padding-left:6px;
  padding-right:6px;
  text-align:center;
  margin-top:16px;
  color:#64b572;
  width:72px;
}
.inputPhone{
  margin-top:3px;
  height:30px;
  font-size:16px;
  color:#333;
  outline:none;
  background:transparent;
  border:none;
  outline:medium;
}
.inputCode{
  margin-top:3px; 
  height: 30px;
  font-size:16px;
  color:#333;
  width:100%;
  background:transparent;
  border:none;
  outline:medium;
}
</style>